import type { AiCollectionId } from "./aiArtworkCatalog";
import { artAsset } from "../lib/artAssets";

export type AiArtwork = {
  id: string;
  imageFile: string;
  imageUrl: string;
  collection: AiCollectionId;
  featured?: boolean;
};

export function aiArtworkImageUrl(imageFile: string): string {
  return artAsset(`ai-arts/${imageFile}.webp`);
}

/** Auto-generated from folder layout — run: npm run publish-arts */
export const aiArtworks: AiArtwork[] = [
  {
    id: "veshavu-action-figures1-realistic",
    imageFile: "veshavu_action_figures1_realistic",
    imageUrl: aiArtworkImageUrl("veshavu_action_figures1_realistic"),
    collection: "action-figures",
    featured: true
  },
  {
    id: "veshavu-action-figures2-realistic",
    imageFile: "veshavu_action_figures2_realistic",
    imageUrl: aiArtworkImageUrl("veshavu_action_figures2_realistic"),
    collection: "action-figures"
  },
  {
    id: "veshavu-action-figures3-realistic",
    imageFile: "veshavu_action_figures3_realistic",
    imageUrl: aiArtworkImageUrl("veshavu_action_figures3_realistic"),
    collection: "action-figures"
  },
  {
    id: "veshavu-action-figures4-realistic",
    imageFile: "veshavu_action_figures4_realistic",
    imageUrl: aiArtworkImageUrl("veshavu_action_figures4_realistic"),
    collection: "action-figures"
  },
  {
    id: "veshavu-action-figures5-realistic",
    imageFile: "veshavu_action_figures5_realistic",
    imageUrl: aiArtworkImageUrl("veshavu_action_figures5_realistic"),
    collection: "action-figures"
  },
  {
    id: "veshavu-action-figures7-realistic",
    imageFile: "veshavu_action_figures7_realistic",
    imageUrl: aiArtworkImageUrl("veshavu_action_figures7_realistic"),
    collection: "action-figures"
  },
  {
    id: "veshavu-action-figures8-realistic",
    imageFile: "veshavu_action_figures8_realistic",
    imageUrl: aiArtworkImageUrl("veshavu_action_figures8_realistic"),
    collection: "action-figures"
  },
  {
    id: "animals-as-couples-animals",
    imageFile: "animals_as_couples_animals",
    imageUrl: aiArtworkImageUrl("animals_as_couples_animals"),
    collection: "animals"
  },
  {
    id: "cat-animals",
    imageFile: "cat_animals",
    imageUrl: aiArtworkImageUrl("cat_animals"),
    collection: "animals"
  },
  {
    id: "deer-animals",
    imageFile: "deer_animals",
    imageUrl: aiArtworkImageUrl("deer_animals"),
    collection: "animals"
  },
  {
    id: "shellfish",
    imageFile: "shellfish",
    imageUrl: aiArtworkImageUrl("shellfish"),
    collection: "animals"
  },
  {
    id: "sissi-with-a-pearl-earing-animals",
    imageFile: "sissi_with_a_pearl_earing_animals",
    imageUrl: aiArtworkImageUrl("sissi_with_a_pearl_earing_animals"),
    collection: "animals"
  },
  {
    id: "swans",
    imageFile: "swans",
    imageUrl: aiArtworkImageUrl("swans"),
    collection: "animals"
  },
  {
    id: "whales-couple-animals",
    imageFile: "whales_couple_animals",
    imageUrl: aiArtworkImageUrl("whales_couple_animals"),
    collection: "animals",
    featured: true
  },
  {
    id: "bright-future-gate",
    imageFile: "bright_future_gate",
    imageUrl: aiArtworkImageUrl("bright_future_gate"),
    collection: "studio"
  },
  {
    id: "acts-vs-words-hands-go-higher-realistic",
    imageFile: "acts_vs_words_hands_go_higher_realistic",
    imageUrl: aiArtworkImageUrl("acts_vs_words_hands_go_higher_realistic"),
    collection: "creative-with-values"
  },
  {
    id: "internal-sea-spirit",
    imageFile: "internal_sea_spirit",
    imageUrl: aiArtworkImageUrl("internal_sea_spirit"),
    collection: "creative-with-values"
  },
  {
    id: "mutant-baby-of-3",
    imageFile: "mutant_baby_of_3",
    imageUrl: aiArtworkImageUrl("mutant_baby_of_3"),
    collection: "animals"
  },
  {
    id: "pond-nice-quiet-place-to-meditate-to",
    imageFile: "pond_nice_quiet_place_to_meditate_to",
    imageUrl: aiArtworkImageUrl("pond_nice_quiet_place_to_meditate_to"),
    collection: "creative-with-values",
    featured: true
  },
  /*{
    id: "rubber-atronout-realistic",
    imageFile: "rubber_atronout_realistic",
    imageUrl: aiArtworkImageUrl("rubber_atronout_realistic"),
    collection: "creative-with-values"
  },*/
  {
    id: "children-book-cover",
    imageFile: "children_book_cover",
    imageUrl: aiArtworkImageUrl("children_book_cover"),
    collection: "drawing-like"
  },
  {
    id: "game3-board-havah",
    imageFile: "game3_board_havah",
    imageUrl: aiArtworkImageUrl("game3_board_havah"),
    collection: "havah-game-board"
  },
  {
    id: "game-board10-havah",
    imageFile: "game_board10_havah",
    imageUrl: aiArtworkImageUrl("game_board10_havah"),
    collection: "havah-game-board"
  },
  {
    id: "game-board2-havah",
    imageFile: "game_board2_havah",
    imageUrl: aiArtworkImageUrl("game_board2_havah"),
    collection: "havah-game-board"
  },
  {
    id: "game-board4-havah",
    imageFile: "game_board4_havah",
    imageUrl: aiArtworkImageUrl("game_board4_havah"),
    collection: "havah-game-board"
  },
  {
    id: "game-board5-havah",
    imageFile: "game_board5_havah",
    imageUrl: aiArtworkImageUrl("game_board5_havah"),
    collection: "havah-game-board"
  },
  {
    id: "game-board7-havah",
    imageFile: "game_board7_havah",
    imageUrl: aiArtworkImageUrl("game_board7_havah"),
    collection: "havah-game-board"
  },
  {
    id: "game-board8-havah",
    imageFile: "game_board8_havah",
    imageUrl: aiArtworkImageUrl("game_board8_havah"),
    collection: "havah-game-board"
  },
  {
    id: "game-board9-havah",
    imageFile: "game_board9_havah",
    imageUrl: aiArtworkImageUrl("game_board9_havah"),
    collection: "havah-game-board"
  },
  {
    id: "game-board-havah",
    imageFile: "game_board_havah",
    imageUrl: aiArtworkImageUrl("game_board_havah"),
    collection: "havah-game-board"
  },
  {
    id: "havah-project-cover-the-women-health-app-havah",
    imageFile: "havah_project_cover_the_women_health_app_havah",
    imageUrl: aiArtworkImageUrl("havah_project_cover_the_women_health_app_havah"),
    collection: "havah",
    featured: true
  },
  {
    id: "heaven-goal-havah",
    imageFile: "heaven_goal_havah",
    imageUrl: aiArtworkImageUrl("heaven_goal_havah"),
    collection: "havah"
  },
  {
    id: "hormonic-periods-of-the-month-woman-health",
    imageFile: "hormonic_periods_of_the_month_woman_health",
    imageUrl: aiArtworkImageUrl("hormonic_periods_of_the_month_woman_health"),
    collection: "havah"
  },
  {
    id: "hungru-960s-call-for-food-critiques",
    imageFile: "hungru_960's_call_for_food_critiques",
    imageUrl: aiArtworkImageUrl("hungru_960's_call_for_food_critiques"),
    collection: "hungru-campaigns"
  },
  {
    id: "hungru-nuetral-call-for-food-critiques",
    imageFile: "hungru_nuetral_call_for_food_critiques",
    imageUrl: aiArtworkImageUrl("hungru_nuetral_call_for_food_critiques"),
    collection: "hungru-campaigns"
  },
  {
    id: "hungru-vibrant-call-for-food-critiques",
    imageFile: "hungru_vibrant_call_for_food_critiques",
    imageUrl: aiArtworkImageUrl("hungru_vibrant_call_for_food_critiques"),
    collection: "hungru-campaigns",
    featured: true
  },
  {
    id: "hungru-vibrant-call-for-food-critiques2",
    imageFile: "hungru_vibrant_call_for_food_critiques2",
    imageUrl: aiArtworkImageUrl("hungru_vibrant_call_for_food_critiques2"),
    collection: "hungru-campaigns"
  },
  {
    id: "butter-flavour-spirit-taste-identity-demo-hungru",
    imageFile: "butter_flavour_spirit_taste_identity_demo_hungru",
    imageUrl: aiArtworkImageUrl("butter_flavour_spirit_taste_identity_demo_hungru"),
    collection: "hungru-flavor-spirit",
    featured: true
  },
  {
    id: "citrus2-flavour-spirit-taste-identity-demo-hungru",
    imageFile: "citrus2_flavour_spirit_taste_identity_demo_hungru",
    imageUrl: aiArtworkImageUrl("citrus2_flavour_spirit_taste_identity_demo_hungru"),
    collection: "hungru-flavor-spirit"
  },
  {
    id: "citrus-flavour-spirit-taste-identity-demo-hungru",
    imageFile: "citrus_flavour_spirit_taste_identity_demo_hungru",
    imageUrl: aiArtworkImageUrl("citrus_flavour_spirit_taste_identity_demo_hungru"),
    collection: "hungru-flavor-spirit"
  },
  {
    id: "honey-flavour-spirit-taste-identity-demo",
    imageFile: "honey_flavour_spirit_taste_identity_demo",
    imageUrl: aiArtworkImageUrl("honey_flavour_spirit_taste_identity_demo"),
    collection: "hungru-flavor-spirit"
  },
  {
    id: "night-guy-flavour-spirit-taste-identity-demo",
    imageFile: "night_guy_flavour_spirit_taste_identity_demo",
    imageUrl: aiArtworkImageUrl("night_guy_flavour_spirit_taste_identity_demo"),
    collection: "hungru-flavor-spirit"
  },
  {
    id: "olive-flavour-spirit-taste-identity-demo",
    imageFile: "olive_flavour_spirit_taste_identity_demo",
    imageUrl: aiArtworkImageUrl("olive_flavour_spirit_taste_identity_demo"),
    collection: "hungru-flavor-spirit"
  },
  {
    id: "pasta-flavour-spirit-taste-identity-demo",
    imageFile: "pasta_flavour_spirit_taste_identity_demo",
    imageUrl: aiArtworkImageUrl("pasta_flavour_spirit_taste_identity_demo"),
    collection: "hungru-flavor-spirit"
  },
  {
    id: "pickles-taste-identity-demo",
    imageFile: "pickles_taste_identity_demo",
    imageUrl: aiArtworkImageUrl("pickles_taste_identity_demo"),
    collection: "hungru-flavor-spirit"
  },
  {
    id: "saint-flavour-spirit-taste-identity-demo",
    imageFile: "saint_flavour_spirit_taste_identity_demo",
    imageUrl: aiArtworkImageUrl("saint_flavour_spirit_taste_identity_demo"),
    collection: "hungru-flavor-spirit"
  },
  {
    id: "seafood-flavour-spirit-taste-identity-demo-hungru",
    imageFile: "seafood_flavour_spirit_taste_identity_demo_hungru",
    imageUrl: aiArtworkImageUrl("seafood_flavour_spirit_taste_identity_demo_hungru"),
    collection: "hungru-flavor-spirit"
  },
  {
    id: "wine-flavour-spirit-taste-identity-demo",
    imageFile: "wine_flavour_spirit_taste_identity_demo",
    imageUrl: aiArtworkImageUrl("wine_flavour_spirit_taste_identity_demo"),
    collection: "hungru-flavor-spirit"
  },
  {
    id: "the-near-future-of-hungru",
    imageFile: "the_near_future_of_hungru",
    imageUrl: aiArtworkImageUrl("the_near_future_of_hungru"),
    collection: "hungru-future",
    featured: true
  },
  {
    id: "olive-human-taste-identity-demo",
    imageFile: "olive_human_taste_identity_demo",
    imageUrl: aiArtworkImageUrl("olive_human_taste_identity_demo"),
    collection: "hungru-taste-identity"
  },
  {
    id: "stew-human-taste-identity-demo",
    imageFile: "stew_human_taste_identity_demo",
    imageUrl: aiArtworkImageUrl("stew_human_taste_identity_demo"),
    collection: "hungru-taste-identity"
  },
  {
    id: "wine-woman-human-taste-identity-demo",
    imageFile: "wine_woman_human_taste_identity_demo",
    imageUrl: aiArtworkImageUrl("wine_woman_human_taste_identity_demo"),
    collection: "hungru-taste-identity",
    featured: true
  },
  {
    id: "inspiration-flows",
    imageFile: "inspiration_flows",
    imageUrl: aiArtworkImageUrl("inspiration_flows"),
    collection: "studio",
    featured: true
  },
  {
    id: "olymus-heaven",
    imageFile: "olymus_heaven",
    imageUrl: aiArtworkImageUrl("olymus_heaven"),
    collection: "studio"
  },
  // {
  //   id: "superman-team2-realistic",
  //   imageFile: "superman_team2_realistic",
  //   imageUrl: aiArtworkImageUrl("superman_team2_realistic"),
  //   collection: "realistic"
  // },
  {
    id: "superman-team-action-figures1-realistic",
    imageFile: "superman_team_action_figures1_realistic",
    imageUrl: aiArtworkImageUrl("superman_team_action_figures1_realistic"),
    collection: "action-figures"
  },
  // {
  //   id: "superman-team-realistic",
  //   imageFile: "superman_team_realistic",
  //   imageUrl: aiArtworkImageUrl("superman_team_realistic"),
  //   collection: "realistic"
  // },
  // {
  //   id: "team-of-one-realistic",
  //   imageFile: "team_of_one_realistic",
  //   imageUrl: aiArtworkImageUrl("team_of_one_realistic"),
  //   collection: "realistic"
  // },
  // {
  //   id: "the-alabanian-groom-realistic",
  //   imageFile: "the_alabanian_groom_realistic",
  //   imageUrl: aiArtworkImageUrl("the_alabanian_groom_realistic"),
  //   collection: "realistic"
  // }
];

export const featuredAiArtworks = aiArtworks.filter((w) => w.featured);
